import React, { useState } from 'react';
import { useMap } from 'react-leaflet';

interface MapUtilityButtonsProps {
  defaultCenter: [number, number];
  defaultZoom: number;
  _mapHeight: number;
}

const MapUtilityButtons: React.FC<MapUtilityButtonsProps> = ({ defaultCenter, defaultZoom, _mapHeight }) => {
  const [fullscreenHovered, setFullscreenHovered] = useState(false);
  const [homeHovered, setHomeHovered] = useState(false);
  const map = useMap();
  const [isFullscreen, setIsFullscreen] = useState(false);

  const getButtonStyle = (isHovered: boolean): React.CSSProperties => ({
    width: 34,
    height: 34,
    borderRadius: 4,
    border: '2px solid #6f42c1',
    background: isHovered ? '#6f42c1' : '#fff',
    fontSize: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    cursor: 'pointer',
    transition: 'background 0.15s',
    marginBottom: 10,
    padding: 0,
  });

  // Fullscreen logic
  const handleFullscreen = () => {
    const mapDiv = document.querySelector('.leaflet-container');
    if (!mapDiv) return;
    if (!isFullscreen) {
      mapDiv.requestFullscreen?.();
      setIsFullscreen(true);
    } else {
      document.exitFullscreen?.();
      setIsFullscreen(false);
    }
  };

  // Listen for exit from fullscreen (user presses ESC, etc)
  React.useEffect(() => {
    const onFullscreenChange = () => {
      if (!document.fullscreenElement) setIsFullscreen(false);
    };
    document.addEventListener('fullscreenchange', onFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  }, []);

  // Home button logic
  const handleHome = () => {
    map.setView(defaultCenter, defaultZoom, { animate: true });
  };

  return (
    <div style={{ position: 'absolute', top: 130, left: 10, zIndex: 1000, display: 'flex', flexDirection: 'column' }}>
      <button
        style={getButtonStyle(fullscreenHovered)}
        title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
        onClick={handleFullscreen}
        onMouseEnter={() => setFullscreenHovered(true)}
        onMouseLeave={() => setFullscreenHovered(false)}
      >
        <i
          className={isFullscreen ? 'ri-fullscreen-exit-line' : 'ri-fullscreen-line'}
          style={{ color: fullscreenHovered ? '#fff' : '#6c3fc5' }}
        />
      </button>
      <button
        style={getButtonStyle(homeHovered)}
        title="Home"
        onClick={handleHome}
        onMouseEnter={() => setHomeHovered(true)}
        onMouseLeave={() => setHomeHovered(false)}
      >
        <i className="ri-home-4-line" style={{ color: homeHovered ? '#fff' : '#6c3fc5' }} />
      </button>
    </div>
  );
};

export default MapUtilityButtons;
